import React, { useEffect, useState } from 'react';

export default function() {
  const [danmakuSwitchOn, setDanmakuSwitchOn] = useState(
    localStorage['danmakuOn'] === '1' ? true : false
  );
  // 根据danmakuSwitchOn来存储值到本地
  useEffect(() => {
    // console.log('danmakuSwitchOn',danmakuSwitchOn);
    localStorage['danmakuOn'] = danmakuSwitchOn ? '1' : '0';
  }, [danmakuSwitchOn]);
  return { danmakuSwitchOn, setDanmakuSwitchOn };
}
